import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText'

console.log("mom get the camera")

gsap.utils.toArray(".up").forEach((elem) => {
      //const split = new SplitText(elem, { type: "words" });
      gsap.set(elem, { y:40 }); //, opacity: 0.4 pour faire une animation d'opacité

      gsap.to(elem, {
        //stagger: { each: 0.08 },
        scrollTrigger: {
          trigger: elem,
          start: "top 70%",
          end: "top 20%",
          scrub: 0.5,
          markers: false
        },
        ease: "power1.out",
        //opacity: 1, //pour l'opacité aussi
        y:0,
      });
    });

  gsap.utils.toArray(".down").forEach((elem) => {
      //const split = new SplitText(elem, { type: "words" });
      gsap.set(elem, { y:-40 }); //, opacity: 0.4 pour faire une animation d'opacité

      gsap.to(elem, {
        //stagger: { each: 0.08 },
        scrollTrigger: {
          trigger: elem,
          start: "top 65%",
          end: "top 20%",
          scrub: 0.5,
          markers: false
        },
        ease: "power1.out",
        //opacity: 1, //pour l'opacité aussi
        y:0,
      });
    });
